// extracted by mini-css-extract-plugin
module.exports = {"main-block":"MainBlock_main-block__2aabk","dark":"MainBlock_dark__2zapk","light":"MainBlock_light__1ZCxL"};